export default __webpack_public_path__ + "static/media/KillerVespa1.a3341034.jpg";